/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClaudeToolUsage = {
  /**
   * Serialized tool input size in bytes.
   */
  inputSizeBytes: number;
  /**
   * Claude prompt.id for the turn that used this tool.
   */
  promptId: string;
  /**
   * Serialized tool result size in bytes.
   */
  resultSizeBytes: number;
  /**
   * Tool name reported by Claude Code.
   */
  toolName: string;
  /**
   * Claude tool_use_id that correlates the tool call and result.
   */
  toolUseId: string;
};

/** @internal */
export const ClaudeToolUsage$inboundSchema: z.ZodMiniType<
  ClaudeToolUsage,
  unknown
> = z.pipe(
  z.object({
    input_size_bytes: z.int(),
    prompt_id: z.string(),
    result_size_bytes: z.int(),
    tool_name: z.string(),
    tool_use_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "input_size_bytes": "inputSizeBytes",
      "prompt_id": "promptId",
      "result_size_bytes": "resultSizeBytes",
      "tool_name": "toolName",
      "tool_use_id": "toolUseId",
    });
  }),
);

export function claudeToolUsageFromJSON(
  jsonString: string,
): SafeParseResult<ClaudeToolUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClaudeToolUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClaudeToolUsage' from JSON`,
  );
}
